import { render, staticRenderFns } from "./DetalheAgendamento.vue?vue&type=template&id=52dbf519&scoped=true"
import script from "./DetalheAgendamento.vue?vue&type=script&lang=js"
export * from "./DetalheAgendamento.vue?vue&type=script&lang=js"
import style0 from "./DetalheAgendamento.vue?vue&type=style&index=0&id=52dbf519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbf519",
  null
  
)

export default component.exports